const ProjectFigure = (props) => {
  return (
		<figure>
			<img src={props.src} alt={props.title} loading="lazy" />
			{props.title && <figcaption>{props.title}</figcaption>}
		</figure>
  )
}

export default ProjectFigure